/** @jsx jsx */
import { CCallout, CModal } from "@coreui/react"
import { css, jsx } from "@emotion/react"
import { useTheme } from "components/common/Context/ThemeContext"
import PropTypes from "prop-types"

import { CMSButton } from "../button"

const useStyles = (theme) => {
  return {
    message: css`
      font-size: 16px;
    `,
    okayBtn: css`
      background-color: ${theme.serviceRequestButton};
      border-color: ${theme.serviceRequestButton};
      min-width: 100px;
      &:hover {
        background-color: ${theme.serviceRequestButton};
        border-color: ${theme.serviceRequestButton};
      }
    `,
    cancelBtn: css`
      background-color: ${theme.cancelBtnBg};
      border-color: ${theme.serviceRequestButton};
      color: ${theme.serviceRequestButton};
      border: 1px solid;
      min-width: 100px;
      &:hover {
        border-color: ${theme.serviceRequestButton};
        color: ${theme.serviceRequestButton};
      }
    `
  }
}

export default function Confirm({
  show,
  setShow,
  onCancel,
  onOkay,
  message,
  sizeOfModal,
  showBackgroundColor,
  disableOkButton = false,
  okayBtnLabel = "OK"
}) {
  const theme = useTheme()
  const classes = useStyles(theme)

  return (
    <CModal
      show={show}
      onClose={() => setShow(false)}
      size={sizeOfModal}
      centered
    >
      <CCallout
        color="warning"
        className={`m-0 py-3 ${
          showBackgroundColor ? "user-success-modal" : ""
        }`}
      >
        <div className="d-flex justify-content-between align-items-start">
          <p css={classes.message} className="w-100">
            {message}
          </p>
        </div>
        <div className="d-flex justify-content-end mt-3">
          {onCancel && (
            <CMSButton
              outline={true}
              type="primary"
              onClick={() => onCancel && onCancel()}
              className="mr-3"
            >
              Cancel
            </CMSButton>
          )}

          <CMSButton
            type="primary"
            onClick={() => onOkay && onOkay()}
            disabled={disableOkButton}
          >
            {okayBtnLabel}
          </CMSButton>
        </div>
      </CCallout>
    </CModal>
  )
}

Confirm.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  onCancel: PropTypes.func,
  onOkay: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sizeOfModal: PropTypes.string,
  showBackgroundColor: PropTypes.bool,
  disableOkButton: PropTypes.bool,
  okayBtnLabel: PropTypes.string
}
